// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_5ea97d0","gameDetails":"_06c54ae","dropdown":"_a0a1f5b","videoChatToggle":"_045ba0c"};